<template>
  <div>
    <div style="width: 100%;">
      <table class="table table-sm table-bordered table-chek">
        <tr>
          <td class="td-one">
            <b class="familya">
              Пациент:
              <!-- Bemor: -->
            </b>
          </td>
          <td class="td-one">
            <div class="data-bemor-chek">{{ datas.bemorId }}</div>
          </td>
          <td>
            <span class="data-bemor-chek">{{ datas.name }}</span>
          </td>
          <!-- <td>
                <b class="familya">
                  Пациент ID
                </b>
              </td> -->
        </tr>
        <tr>
          <td colspan="2" class="td-two">
            <b class="familya">
              Дата рождения:
              <!-- Tug'ilgan kuni: -->
            </b>
          </td>
          <td>
            <span class="data-bemor-chek">{{ datas.birthday | moment }}</span>
          </td>
          <!-- <td rowspan="2">
                  <div class="data-bemor-chek">{{ datas.bemorId }}</div>
              </td> -->
        </tr>
        <tr>
          <td colspan="2" class="td-two">
            <b class="familya">
              Дата обследования:
              <!-- Qabul sanasi: -->
            </b>
          </td>
          <td>
            <span class="data-bemor-chek"> {{ date | momentDate }}</span>
          </td>
        </tr>
        <tr v-if="bolim">
          <td colspan="2" class="td-two">
            <b class="familya">
              Отдел:
              <!-- Bo'lim -->
            </b>
          </td>
          <td>
            <span class="data-bemor-chek"> {{ bolim }}</span>
          </td>
        </tr>
        <tr v-if="name">
          <td colspan="2" class="td-two">
            <b class="familya">
              Обследование:
              <!-- Tibbiy ko'rik: -->
            </b>
          </td>
          <td>
            <span class="data-bemor-chek"> {{ name }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="td-two">
            <b class="familya">
              Врач:
              <!-- Shifokor: -->
            </b>
          </td>
          <td>
            <span class="data-bemor-chek"> {{ doctor_name }}</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: ["datas", "date", "name", "bolim", "doctor_name"],
  data() {
    return {};
  },
  filters: {
    momentSS: function(date) {
      if (date) {
        let d = new Date(date * 1000);

        let options = {
          weekday: "short",
          day: "2-digit",
          month: "long",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true
        };
        return d.toLocaleString("ru-RU", options);
      } else {
        return "";
      }
    },
    moment: function(date) {
      if (date) {
        return moment.unix(date).format("DD.MM.YYYY");
      } else {
        return "";
      }
    },
    momentDate: function(date) {
      if (date) {
        let x = moment(new Date(date).getTime()).format("DD.MM.YYYY HH:mm");
        return x;
      } else {
        return "";
      }
    },
    yoshniAniqlash: function(data) {
      if (data) {
        let yil = parseInt(moment.unix(data).format("YYYY"));
        let joriyYil = new Date().getFullYear();
        return joriyYil - yil;
      } else {
        return "";
      }
    }
  }
};
</script>
<style>
.familya {
  /* background: rgb(70, 112, 250) !important; */
  /* display: flex; */
  /* text-align: center; */
  /* width: 300px; */
  font-family: "Times New Roman", Times, serif;
  font-size: 14pt !important;
}
.data-bemor-chek {
  font-family: "Times New Roman", Times, serif;
  font-size: 14pt;
  font-weight: 600;
}
.table-chek td {
  padding: 0px 7px !important;
  border: 1px solid #000 !important;
}
.td-two {
  width: 204px;
  background: #d6d5d5 !important;
}
.td-one {
  width: 110px;
  background: #d6d5d5 !important;
}
</style>
